export default "__VITE_ASSET__DsWpgDS2__"